import { useMutation } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { INeshanQueryParamsType, INeshanResponseType } from './type'
import { IResponseType } from '@/types/response-type'

export function useNeshan({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<INeshanQueryParamsType>) {
  return useMutation<INeshanResponseType, Error, INeshanQueryParamsType>({
    mutationFn: async (data) => {
      const response = await APIInstance<INeshanResponseType>({
        url: 'mrf/address/geolocation/',
        method: 'post',
        data
      })
      return response.data
    },
    retry: 0,
    mutationKey: ['neshanAddress', data],
    ...rest
  })
}
